import store from "@/store";
import { loadSession } from "@/services/auth";

/**
 * O usuário fica persistido no localStorage (vuex-persist), então o F5 reidrata
 * a store com o que era verdade no carregamento anterior — permissões, vínculo
 * e o limite de atendimentos simultâneos inclusive. Quem decidir rota antes de
 * `GET /auth` responder decide com dado velho.
 *
 * Este módulo centraliza esse carregamento para que a guarda de rota e o App
 * compartilhem uma única requisição por carregamento de página, em vez de
 * dispararem duas.
 */
let pending = null;
let fetchedAt = 0;

/**
 * Recarrega a sessão e atualiza a store, sempre indo à API.
 *
 * Devolve também o usuário anterior à atualização: quando a promessa resolve a
 * store já foi sobrescrita, e quem chama precisa do valor antigo para saber o
 * que mudou (os filtros são limpos quando os grupos de permissão mudam).
 */
export function refreshSession() {
  const previousUser = store.getters.user;

  fetchedAt = Date.now();
  pending = loadSession().then(({ data }) => {
    store.dispatch("setUser", data);

    return { user: data, previousUser };
  });

  return pending;
}

/**
 * Garante a sessão carregada uma única vez por carregamento de página,
 * reaproveitando a requisição em voo (ou já concluída). Uma falha também fica
 * guardada de propósito: sessão expirada cai no signOut do interceptor, e
 * repetir o `GET /auth` a cada navegação só empilharia erro.
 *
 * Use `refreshSession` quando o objetivo for justamente buscar de novo — depois
 * do login ou de uma alteração no próprio perfil, por exemplo.
 */
export function ensureSession() {
  return pending || refreshSession();
}

/**
 * Recarrega a sessão se a última carga já passou de `maxAge`; caso contrário
 * reaproveita a que existe.
 *
 * Para quem decide tela pelo limite de atendimentos simultâneos, a sessão do
 * carregamento da página não serve: o admin muda o limite com a sessão do
 * atendente aberta, e navegar sem F5 decidiria com o valor velho. A janela
 * curta existe só para um redirecionamento em cadeia não refazer o `GET /auth`
 * que acabou de responder.
 */
export function ensureFreshSession(maxAge = 2000) {
  if (pending && Date.now() - fetchedAt <= maxAge) return pending;

  return refreshSession();
}
